export enum DeviceModelType {
    PASSENGER_COUNT='1001',
    TRACKING='1002',
    VALIDATOR='1003',
    RECHARGER='1004'
}